import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useLoad } from "./common";
import Dashboard from "./Dashboard";
import ReportSales from "./ReportSales";
import ReportFinance from "./ReportFinance";
import History from "./History";
import Setting from "./Setting";
import MetaAds from "../../../pages/MetaAds";

const MGMT = ["owner", "supervisor"];
const MENUS = [
    ["dashboard", "Dashboard", ["owner", "supervisor"]],
    ["sales", "Report Sales", ["owner", "supervisor", "admin_sales"], "Sales"],
    ["finance", "Report Finance", ["owner", "finance", "supervisor"], "Finance"],
    ["meta", "Meta Ads", MGMT],
    ["history", "History", ["owner", "supervisor", "admin_sales", "finance"]],
    ["setting", "Setting", ["owner", "supervisor"]],
];

export default function ReportingV2() {
    const { user } = useAuth();
    const [cfg, reloadCfg] = useLoad("/reporting/v2/config");
    const mgmt = MGMT.includes(user?.role);
    const menus = MENUS.filter((m) => m[2].includes(user?.role)).map(([k, l, , ml]) => [k, mgmt && ml ? ml : l]);
    const [menu, setMenu] = useState(menus[0]?.[0]);
    const [focus, setFocus] = useState(null);
    const open = (m, f) => { setFocus(f || null); setMenu(m); };
    if (!cfg) return <div className="text-sm text-neutral-400">Memuat…</div>;
    return (
        <div className="reporting-ui space-y-5 pb-10" data-testid="reporting-v2">
            <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-400">H&T Group</div>
                <h1 className="font-serif text-3xl md:text-4xl tracking-tight">Reporting</h1>
            </div>
            <nav className="flex flex-wrap gap-x-1 border-b border-mist" data-testid="v2-menu">
                {menus.map(([k, l]) => (
                    <button key={k} type="button" onClick={() => open(k)} data-testid={`v2-menu-${k}`}
                        className={`shrink-0 px-2.5 md:px-3 py-2.5 text-[11px] md:text-xs uppercase tracking-wider md:tracking-widest border-b-2 transition-colors ${menu === k ? "border-ink text-ink" : "border-transparent text-neutral-400 hover:text-ink"}`}>{l}</button>
                ))}
            </nav>
            {menu === "dashboard" && <Dashboard open={open} />}
            {menu === "sales" && <ReportSales cfg={cfg} focus={focus} />}
            {menu === "finance" && <ReportFinance cfg={cfg} focus={focus} />}
            {menu === "meta" && <MetaAds embedded />}
            {menu === "history" && <History open={open} cfg={cfg} />}
            {menu === "setting" && <Setting cfg={cfg} onSaved={reloadCfg} isOwner={user?.role === "owner"} />}
        </div>
    );
}
